var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "authorize-box"
  }, [_c('div', [_c('a-card', {
    staticClass: "authorize-box-loading",
    attrs: {
      "bordered": false
    }
  }, [_c('div', {
    staticClass: "authorize-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('img', {
    staticClass: "app-header-logo",
    attrs: {
      "src": require("@/assets/images/logo.png")
    }
  }), _c('div')]), _c('div', {
    staticClass: "authorize-content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.loading,
      expression: "loading"
    }]
  }, [_c('a-icon', {
    staticStyle: {
      "font-size": "40px"
    },
    attrs: {
      "type": "loading"
    }
  })], 1), _c('div', [_c('p', [_vm._v(_vm._s(_vm.message))])])])])], 1)]);
};

var staticRenderFns = [];
export { render, staticRenderFns };